<section class="financiamiento-section">
    <div class="financiamiento-overlay"></div>
    <div class="hero-container">
        <h1 class="hero-title animate-hero-title">
            External CFO (Tercerización/Outsourcing Financiero)
        </h1>
    </div>
</section>

<section class="services-detail-section" #servicesSection>
    <div class="container">

        <!-- Texto introductorio - ANCHO COMPLETO -->
        <div class="services-left" style="padding-bottom: 2rem;">
            <h2 class="services-intro animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
                Nos convertimos en el Director Financiero externo de tu empresa. Ideal para empresas que necesitan
                una dirección financiera profesional sin incorporar un CFO a tiempo completo.
            </h2>
        </div>

        <div class="services-detail-content">

            <!-- Columna izquierda: Imagen -->
            <div class="services-left">
                <div class="services-image animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
                    <img src="/assets/Tarjetas servicios/3 external CFO.jpg" alt="External CFO">
                </div>
            </div>

            <!-- Columna derecha: Lista de servicios -->
            <div class="services-right">
                <ul class="services-list">
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Reuniones periódicas con la dirección.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.4s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Elaboración de reportes gerenciales.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.5s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Seguimiento de indicadores.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.6s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Coordinación con estudio contable, banco e inversores.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.7s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Definición de estrategia financiera.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.8s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Participación en decisiones de inversión y financiamiento.</span>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>

<app-cta-section></app-cta-section>